module.exports = __webpack_public_path__ + "static/media/mraBlog3.db018018.jpg";